import { useMemo, useRef } from 'react';
type Pos = { x: number; y: number };

export type RelativeDragHandlers = {
  onDragStart: (ev: React.DragEvent) => void;
  onDrag: (
    ev: React.DragEvent,
    onMove: (nextPos: Pos, startPos: Pos) => void
  ) => void;
  onDragEnd: (ev: React.DragEvent) => void;
};

export const useRelativeDrag = (): RelativeDragHandlers => {
  const dragStart = useRef<Pos | null>(null);
  const firstMoveEvent = useRef(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  return useMemo(
    () => ({
      onDragStart: (ev) => {
        dragStart.current = { x: ev.clientX, y: ev.clientY };
        firstMoveEvent.current = true;
      },
      onDrag: (ev, onMove) => {
        ev.persist();
        timeoutRef.current = setTimeout(() => {
          if (!dragStart.current) {
            return;
          }
          if (firstMoveEvent.current) {
            firstMoveEvent.current = false;
            return;
          }

          if (ev.clientX === 0) {
            // user probably moved out of the viewport - do not react to this
            return;
          }

          onMove(
            {
              x: ev.clientX - dragStart.current.x,
              y: ev.clientY - dragStart.current.y
            },
            {
              x: dragStart.current.x,
              y: dragStart.current.y
            }
          );
        }, 10);
      },
      onDragEnd: () => {
        firstMoveEvent.current = false;
        dragStart.current = null;
        timeoutRef.current && clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    }),
    []
  );
};
